import {
    SyncsWithUrl,
    ResetsPage,
} from "clockvine-vue"

export default {
    mixins: [
        new SyncsWithUrl('params'),
        new ResetsPage(),
    ],

    data: () => ({
        params: {
            page: 1,
            type: null,
            product: null,
            industry: null,
        },
    }),
}
